import { getApplicationSettings } from "owa-application-settings";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { logGreyError } from "owa-analytics";
import { getPresenceCloudConfig } from "../config/cloudConfig";

let upsBaseUrl: string;
let _lazyIsInitialized = false;

const initializeBaseUrl = () => {
    const mailboxInfo = getModuleContextMailboxInfo();
    if (isAccountFeatureEnabled("msplaces-presence-resource-appsetting", mailboxInfo)) {
        try {
            upsBaseUrl = getApplicationSettings("PresenceResource", mailboxInfo).baseEndpoint;
            return;
        }
        catch {
            logGreyError("PresenceApplicationSettingError", mailboxInfo);
        }
    }
    upsBaseUrl = getPresenceCloudConfig().upsBaseUrl;
};

export function getUPSBaseUrl(): string {
    if (!_lazyIsInitialized) {
        initializeBaseUrl();
        _lazyIsInitialized = true;
    }
    return upsBaseUrl;
}

export function setUPSBaseUrl(url: string): void {
    upsBaseUrl = url;
}
